module.exports = __webpack_public_path__ + "img/generic-rating-sorting-asc.fb93b08e.png";